import { Box, Skeleton } from '@mui/material'

const SegmentMiniRules = () => {
    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0.4,
                mt: 0.5
            }}
        >
            <Skeleton
                variant="rectangular"
                width={100}
                height={20}
                sx={{
                    borderRadius: '8px'
                }}
            />
        </Box>
    )
}

export default SegmentMiniRules
